const stripTrailingSlashes = (url) => {
  if (!url || typeof url !== "string") return url;
  return url.replace(/\/+$/, "");
};

// Không để dấu / cuối — tránh //api/... khi nối `${domain}${path}`
export const domainServer = stripTrailingSlashes(
  process.env.REACT_APP_SERVER_API
);
export const wsDomain = stripTrailingSlashes(process.env.REACT_APP_WS_API);
export const domainAutoLogin = stripTrailingSlashes(
  process.env.REACT_APP_AUTOLOGIN_API
);
export const secretKey = process.env.REACT_APP_ACC_GAME_SECRET_KEY;
